const translation = {
  common: {
    appName: "KitAuto",
    home: "Accueil",
    search: "Rechercher",
    wishlist: "Liste de souhaits",
    cart: "Panier",
    notifications: "Notifications",
    noNotifications: "Aucune notification",
    profile: "Profil",
    manageProfile: "Gérer le profil",
    logout: "Déconnexion",
    signOut: "Se déconnecter",
    welcome: "Bienvenue",
    signInPrompt: "Connectez-vous à votre compte",
    or: "OU",
    changeLanguage: "Changer de langue",
    languages: {
      en: "Anglais",
      fr: "Français"
    },
    createAccount: "Créer un compte",
    signUpPrompt: "Créez votre compte pour commencer",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    anonymous: "Anonyme",
    logoutSuccess: "Vous avez été déconnecté avec succès"
  },
  product: {
    addNew: "Ajouter un produit",
    addToCart: "Ajouter au panier",
    addToWishlist: "Ajouter aux favoris",
    categories: {
      body: "Carrosserie",
      electrical: "Pièces électriques",
      engine: "Pièces moteur",
      transmission: "Transmission",
      brakes: "Freins",
      suspension: "Suspension",
      interior: "Intérieur",
      accessories: "Accessoires"
    },
    conditions: {
      new: "Neuf",
      used: "Occasion",
      refurbished: "Reconditionné"
    },
    basicInfo: "Informations de base",
    detailsSpecs: "Détails et spécifications",
    imagesPreview: "Images et aperçu",
    addNewProduct: "Ajouter un nouveau produit",
    title: "Titre",
    description: "Description",
    price: "Prix",
    category: "Catégorie",
    condition: "État",
    back: "Retour",
    next: "Suivant",
    addImages: "Ajouter des images",
    uploadLimit: "Maximum 5 images autorisées",
    stock: "Stock",
    brand: "Marque",
    model: "Modèle",
    location: "Localisation",
    brandPlaceholder: "Entrez le nom de la marque",
    modelPlaceholder: "Entrez le nom du modèle",
    locationPlaceholder: "Entrez la localisation",
    year: {
      label: "Année",
      placeholder: "Entrez l'année",
      errors: {
        required: "L'année est requise",
        invalid: "Année invalide",
        future: "L'année ne peut pas être dans le futur",
        tooOld: "L'année ne peut pas être avant 1900"
      }
    },
    form: {
      errors: {
        validation: "Veuillez corriger les erreurs signalées avant de soumettre",
        title: "Le formulaire contient des erreurs",
        description: "Vérifiez le formulaire et corrigez les champs signalés"
      }
    },
    pleaseAddImage: "Veuillez ajouter au moins une image",
    saving: "Enregistrement...",
    visibility: {
      visible: "Visible",
      hidden: "Masqué"
    },
    visibilityUpdated: "Visibilité du produit mise à jour avec succès",
    image: "Image",
    share: "Partager",
    sellerInfo: "Informations sur le vendeur",
    stockCount: "{{count}} en stock",
    additionalInfo: "Informations supplémentaires",
    shipping: {
      title: "Livraison",
      description: "Livraison gratuite pour les commandes de plus de 100€. Délai de livraison standard 3-5 jours ouvrables."
    },
    payment: {
      title: "Paiement",
      description: "Paiement sécurisé via nos prestataires de paiement de confiance."
    },
    warranty: {
      title: "Garantie",
      description: "Politique de retour de 30 jours pour les articles non utilisés dans leur emballage d'origine."
    },
    message: {
      contactSeller: "Contacter le vendeur",
      writeMessage: "Écrire un message",
      placeholder: "Écrivez votre message ici...",
      send: "Envoyer le message"
    },
    specifications: {
      attribute: "Attribut",
      value: "Valeur"
    },
    memberSince: "Membre depuis",
    contactSeller: "Contacter le vendeur",
    removeFromWishlist: "Retirer des favoris",
    wishlist: {
      addedToWishlist: "Ajouté aux favoris",
      removedFromWishlist: "Retiré des favoris"
    },
    details: {
      messageSuccess: "Message envoyé avec succès",
      messageError: "Échec de l'envoi du message",
      outOfStock: "En rupture de stock",
      inStock: "En stock",
      quantity: "Quantité",
      sendingMessage: "Envoi en cours...",
      messagePlaceholder: "Écrivez votre message ici...",
      messageMaxLength: "Le message ne peut pas dépasser 500 caractères",
      messageRequired: "Veuillez entrer un message"
    },
    cart: {
      addedToCart: "Ajouté au panier",
      failedToAdd: "Échec de l'ajout au panier"
    },
    unavailable: "Produit non disponible",
    addedSuccessProduct: "Produit ajouté avec succès\n, il sera visible après approbation",
    reviews: {
      title: "Avis",
      addReview: "Ajouter un avis",
      noReviews: "Aucun avis pour le moment"
    }
  },
  auth: {
    login: "Connexion",
    register: "Inscription",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser le mot de passe",
    sendResetLink: "Envoyer le lien de réinitialisation",
    backToLogin: "Retour à la connexion",
    loginWithGoogle: "Se connecter avec Google",
    registerWithGoogle: "S'inscrire avec Google",
    name: "Nom complet",
    noAccount: "Vous n'avez pas de compte ?",
    hasAccount: "Vous avez déjà un compte ?",
    loginError: "Échec de la connexion. Veuillez vérifier vos identifiants.",
    registerError: "Échec de l'inscription. Veuillez réessayer.",
    resetSuccess: "Lien de réinitialisation envoyé à votre email",
    resetError: "Échec de l'envoi du lien de réinitialisation",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    signInWith: {
      google: "Se connecter avec Google",
      facebook: "Se connecter avec Facebook"
    },
    signUpWith: {
      google: "S'inscrire avec Google",
      facebook: "S'inscrire avec Facebook"
    },
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signup: {
      title: "Créer un compte",
      subtitle: "Rejoignez notre communauté",
      name: {
        label: "Nom complet",
        placeholder: "Entrez votre nom complet",
        required: "Le nom est requis"
      },
      email: {
        label: "Adresse email",
        placeholder: "Entrez votre email",
        required: "L'email est requis",
        invalid: "Veuillez entrer un email valide"
      },
      password: {
        label: "Mot de passe",
        placeholder: "Créez un mot de passe",
        required: "Le mot de passe est requis",
        minLength: "Le mot de passe doit contenir au moins 6 caractères",
        requirements: "Le mot de passe doit contenir des lettres, des chiffres et des caractères spéciaux"
      },
      confirmPassword: {
        label: "Confirmer le mot de passe",
        placeholder: "Confirmez votre mot de passe",
        required: "Veuillez confirmer votre mot de passe",
        mismatch: "Les mots de passe ne correspondent pas"
      },
      submit: "Créer un compte",
      alreadyHaveAccount: "Vous avez déjà un compte ?",
      signIn: "Connectez-vous ici",
      or: "ou continuez avec",
      terms: {
        agree: "En vous inscrivant, vous acceptez nos",
        termsLink: "Conditions d'utilisation",
        and: "et",
        privacyLink: "Politique de confidentialité"
      },
      success: "Compte créé avec succès",
      error: {
        default: "Échec de la cration du compte",
        emailInUse: "Cet email est déjà utilisé",
        weak: "Le mot de passe est trop faible",
        invalid: "Format d'email invalide"
      },
      form: {
        title: "S'inscrire",
        name: "Nom",
        email: "Email",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        button: "S'inscrire",
        googleButton: "S'inscrire avec Google",
        facebookButton: "S'inscrire avec Facebook",
        haveAccount: "Vous avez déjà un compte ?",
        loginLink: "Connectez-vous ici",
        errors: {
          nameRequired: "Le nom est requis",
          emailRequired: "L'email est requis",
          emailInvalid: "Format d'email invalide",
          passwordRequired: "Le mot de passe est requis",
          passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
          confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
          passwordsNotMatch: "Les mots de passe ne correspondent pas"
        }
      }
    },
    fullName: "Nom complet",
    phoneNumber: "Numéro de téléphone",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    errors: {
      // Sign In Errors
      invalidEmail: "Adresse email invalide",
      invalidPassword: "Mot de passe invalide",
      emailRequired: "L'email est requis",
      passwordRequired: "Le mot de passe est requis",
      wrongCredentials: "Email ou mot de passe incorrect",
      accountNotFound: "Aucun compte trouvé avec cet email",
      
      // Sign Up Errors
      nameRequired: "Le nom est requis",
      phoneRequired: "Le numéro de téléphone est requis",
      emailInUse: "Cet email est déjà utilisé",
      passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
      invalidPhoneNumber: "Format de numéro de téléphone invalide",
      
      // Social Login Errors
      socialLoginFailed: "Échec de la connexion avec {{provider}}",
      
      // General Errors
      defaultError: "Une erreur s'est produite. Veuillez réessayer.",
      networkError: "Erreur réseau. Veuillez vérifier votre connexion.",
      tooManyAttempts: "Trop de tentatives. Veuillez réessayer plus tard."
    },
    validation: {
      required: "Ce champ est requis",
      email: {
        required: "L'email est requis",
        invalid: "Adresse email invalide"
      },
      password: {
        required: "Le mot de passe est requis",
        minLength: "Le mot de passe doit contenir au moins 6 caractères"
      },
      name: {
        required: "Le nom est requis"
      },
      phone: {
        required: "Le numéro de téléphone est requis",
        invalid: "Format de numéro de téléphone invalide"
      },
      positiveNumber: "Doit être un nombre positif",
      integer: "Doit être un nombre entier",
      stockMin: "Le stock doit être au moins 0"
    }
  },
  search: {
    mainTitle: "Trouver des Pièces Auto",
    subTitle: "Recherchez parmi des milliers de pièces auto",
    searchParts: "Rechercher des pièces...",
    category: "Catégorie",
    allCategories: "Toutes les Catégories",
    categories: {
      engine: "Moteur",
      transmission: "Transmission",
      brakes: "Freins",
      suspension: "Suspension",
      electrical: "Électrique",
      body: "Carrosserie"
    },
    filters: "Filtres",
    sortBy: "Trier par",
    sortOptions: {
      newest: "Plus récent",
      priceLow: "Prix: croissant",
      priceHigh: "Prix: décroissant",
      popular: "Plus populaire"
    },
    viewProduct: "Voir le produit",
    shareProduct: "Partager le produit",
    moreActions: "Plus d'actions",
    noResults: "Aucun produit trouvé",
    tryDifferentFilters: "Essayez d'autres filtres ou termes de recherche",
    tryAgain: "Essayez d'autres termes de recherche",
    noMoreProducts: "Plus de produits à charger"
  },
  validation: {
    required: "Ce champ est requis",
    positiveNumber: "Doit être un nombre positif",
    integer: "Doit être un nombre entier",
    stockMin: "Le stock doit être au moins 0",
    fields: {
      title: "Le titre est requis",
      description: "La description est requise",
      price: "Le prix est requis",
      brand: "La marque est requise",
      model: "Le modèle est requis",
      category: "La catégorie est requise",
      condition: "L'état est requis",
      location: "La localisation est requise",
      stock: "Le stock est requis",
      images: "Au moins une image est requise"
    }
  },
  profile: {
    myProducts: "Mes Produits",
    messages: "Messages",
    orders: {
      orders: "Commandes",
      placed: "Commandes passées",
      received: "Commandes reçues"
    },
    settings: "Paramètres",
    info: {
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      company: "Entreprise",
      companyNotAdded: "Aucune entreprise ajoutée",
      phoneNotAdded: "Aucun numéro de téléphone ajouté",
      addressNotAdded: "Aucune adresse ajoutée"
    },
    buttons: {
      editProfile: "Modifier le profil",
      saveChanges: "Enregistrer les modifications"
    },
    accountSettings: "Paramètres du compte",
    security: "Sécurité",
    changePassword: "Changer le mot de passe",
    changePasswordDesc: "Mettez à jour votre mot de passe pour sécuriser votre compte",
    change: "Modifier",
    notifications: "Notifications",
    enableNotifications: "Activer les notifications",
    enableNotificationsDesc: "Recevoir des notifications sur l'activité de votre compte",
    messageNotifications: "Notifications de messages",
    messageNotificationsDesc: "Être notifié lors de la réception de nouveaux messages",
    orderNotifications: "Notifications de commandes",
    orderNotificationsDesc: "Être notifié des mises à jour du statut de vos commandes",
    settingsUpdated: "Paramètres de notification mis à jour avec succès",
    settingsUpdateError: "Échec de la mise à jour des paramètres de notification",
    privacy: "Confidentialité",
    profileVisibility: "Visibilité du profil",
    profileVisibilityDesc: "Rendre votre profil visible aux autres utilisateurs",
    dangerZone: "Zone dangereuse",
    deleteAccount: "Supprimer le compte",
    product: {
      menu: {
        view: "Voir le produit",
        edit: "Modifier le produit",
        delete: "Supprimer le produit",
        toggleVisibility: {
          show: "Afficher le produit",
          hide: "Masquer le produit"
        }
      },
      inStock: "en stock"
    },
    deleteProduct: "Supprimer le produit",
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer ce produit ?",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    deleteAccountWarning: "Cette action ne peut pas être annulée. Toutes vos données seront définitivement supprimées.",
    confirmDelete: "Confirmer la suppression",
    noOrders: "Pas de commandes",
    startShopping: "Commencer les achats",
    messages: {
      title: "Messages",
      regarding: "Concernant",
      selectConversation: "Sélectionnez une conversation",
      empty: "Pas de messages",
      conversationWith: "Conversation avec {{name}}",
      quickReplies: {
        yes: "Oui, disponible",
        no: "Non disponible",
        price: "Prix ferme",
        negotiate: "Négociable",
        thanks: "Merci"
      },
      typing: "Écrivez un message...",
      justNow: "Maintenant",
      minutesAgo: "{{minutes}}m",
      hoursAgo: "{{hours}}h",
      yesterday: "Hier",
      daysAgo: "{{days}} jours",
      messagesSent: "Message envoyé avec succès",
      messageError: "Erreur lors de l'envoi du message"
    },
    labels: {
      name: "Nom",
      bio: "Biographie",
      phone: "Numéro de téléphone",
      address: "Adresse",
      company: "Nom de l'entreprise"
    },
    noProducts: "Vous n'avez pas encore ajouté de produits",
    addProduct: "Ajouter un produit",
    order: {
      orderId: "Commande #{{id}}",
      status: {
        pending: "En attente",
        processing: "En cours",
        shipped: "Expédié",
        delivered: "Livré",
        completed: "Terminé",
        cancelled: "Annulé"
      },
      quantity: "Quantité",
      total: "Total",
      buyer: "Acheteur",
      contact: "Contact",
      address: "Adresse de livraison"
    },
    noReceivedOrders: "Aucune commande reçue",
    stats: {
      products: "Produits",
      messages: "Conversations",
      orders: "Commandes",
      favorites: "Favoris"
    },
    productDeleted: "Produit supprimé avec succès",
    deleteError: "Échec de la suppression du produit",
    deleteProduct: "Supprimer le produit",
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer ce produit ?",
    profileUpdated: "Profil mis à jour avec succès"
  },
  editProduct: {
    title: "Modifier le produit",
    labels: {
      title: "Titre",
      description: "Description",
      price: "Prix",
      category: "Catégorie",
      brand: "Marque",
      model: "Modèle",
      year: "Année",
      condition: "État",
      stock: "Stock",
      location: "Localisation"
    },
    images: {
      title: "Images du produit",
      currentImages: "Images actuelles",
      delete: "Supprimer l'image",
      addMore: "Ajouter des images",
      uploadLimit: "Maximum 5 images autorisées"
    },
    buttons: {
      save: "Enregistrer les modifications"
    },
    updateSuccess: "Produit mis à jour avec succès"
  },
  wishlist: {
    title: "Ma Liste de Souhaits",
    empty: "Votre liste de souhaits est vide",
    startShopping: "Commencer les Achats",
    removeFromWishlist: "Retirer des favoris",
    removeSuccess: "Produit retiré des favoris",
    removeError: "Échec du retrait du produit des favoris",
    addToCart: "Ajouter au panier",
    addToCartSuccess: "Produit ajouté au panier",
    addToCartError: "Échec de l'ajout au panier"
  },
  cart: {
    title: "Panier",
    empty: "Votre panier est vide",
    startShopping: "Commencer les achats",
    summary: "Résumé de la commande",
    subtotal: "Sous-total",
    shipping: "Livraison",
    total: "Total",
    checkout: "Passer à la caisse",
    remove: "Supprimer",
    quantity: "Quantité",
    updateQuantity: "Modifier la quantité",
    free: "Gratuit",
    itemRemoved: "Article retiré du panier",
    removeError: "Échec de la suppression de l'article",
    quantityUpdated: "Quantité mise à jour",
    updateError: "Échec de la mise à jour de la quantité",
    items: "{{count}} articles",
    item: "{{count}} article",
    estimatedTotal: "Total estimé"
  },
  checkout: {
    title: "Paiement",
    shippingAddress: "Adresse de livraison",
    paymentMethod: "Moyen de paiement",
    orderSummary: "Résumé de la commande",
    billingAddress: "Adresse de facturation",
    sameAsShipping: "Identique à l'adresse de livraison",
    placeOrder: "Passer la commande",
    backToCart: "Retour au panier",
    fields: {
      fullName: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      city: "Ville",
      state: "État/Région",
      zipCode: "Code postal",
      country: "Pays",
      cardNumber: "Numéro de carte",
      expiryDate: "Date d'expiration",
      cvv: "CVV"
    },
    summary: {
      subtotal: "Sous-total",
      shipping: "Livraison",
      total: "Total",
      items: "{{count}} articles",
      item: "{{count}} article"
    },
    validation: {
      required: "Ce champ est requis",
      invalidEmail: "Adresse email invalide",
      invalidPhone: "Numéro de téléphone invalide",
      invalidCard: "Numéro de carte invalide",
      invalidExpiry: "Date d'expiration invalide",
      invalidCVV: "CVV invalide",
      fillRequired: "Veuillez remplir tous les champs obligatoires"
    },
    success: {
      title: "Commande passée avec succès !",
      message: "Merci pour votre commande. Vous recevrez un email de confirmation sous peu.",
      continue: "Continuer les achats"
    },
    error: {
      title: "Erreur",
      message: "Un problème est survenu lors du traitement de votre commande. Veuillez réessayer.",
      retry: "Réessayer"
    },
    form: {
      shippingDetails: "Détails de livraison",
      paymentDetails: "Détails du paiement",
      cardInfo: "Informations de carte",
      saveForNextTime: "Sauvegarder pour la prochaine fois",
      differentBilling: "Utiliser une adresse de facturation différente",
      billingInfo: "Informations de facturation",
      paymentInfo: "Informations de paiement",
      orderDetails: "Détails de la commande",
      saveCard: "Sauvegarder la carte pour les achats futurs",
      termsAccept: "J'accepte les conditions générales",
      shippingMethod: "Mode de livraison",
      standardShipping: "Livraison standard (3-5 jours ouvrables)",
      expressShipping: "Livraison express (1-2 jours ouvrables)",
      freeShippingNote: "Livraison gratuite pour les commandes de plus de 100€",
      cashOnDelivery: "Paiement à la livraison",
      cashDescription: "Payez à la réception de votre commande",
      creditCard: "Carte de crédit/débit",
      cardDescription: "Paiement en ligne sécurisé",
      bankTransfer: "Virement bancaire",
      bankDescription: "Virement bancaire direct",
      selectPayment: "Sélectionnez le mode de paiement"
    },
    placeholders: {
      cardNumber: "1234 5678 9012 3456",
      expiryDate: "MM/AA",
      cvv: "123"
    },
    messages: {
      processing: "Traitement de votre commande...",
      cardDeclined: "Votre carte a été refusée",
      invalidShipping: "Veuillez remplir tous les détails de livraison",
      invalidPayment: "Veuillez remplir tous les détails de paiement",
      orderProcessing: "Traitement de votre commande...",
      orderSuccess: "Commande passée avec succès !",
      orderError: "Erreur lors de la commande",
      shippingError: "Veuillez remplir tous les détails de livraison",
      paymentError: "Veuillez remplir tous les détails de paiement",
      cardError: "Détails de carte invalides"
    },
    buttons: {
      continue: "Continuer",
      back: "Retour",
      placeOrder: "Passer la commande",
      cancel: "Annuler la commande",
      next: "Suivant"
    },
    emptyCart: "Votre panier est vide. Veuillez ajouter des articles avant de procéder au paiement.",
    free: "Gratuit",
    quantity: "Quantité"
  },
  orderSuccess: {
    title: "Commande passée avec succès !",
    subtitle: "Merci pour votre commande. Nous vous enverrons un email de confirmation avec les détails de votre commande.",
    orderId: "Commande #{{id}}",
    paymentMessages: {
      cash: "Veuillez avoir le paiement prêt lors de la livraison de votre commande.",
      processed: "Votre paiement a été traité avec succès."
    },
    buttons: {
      continueShopping: "Continuer les achats",
      viewOrders: "Voir les commandes"
    }
  },
  breadcrumbs: {
    home: "Accueil",
    parts: "Pièces",
    categories: {
      body: "Carrosserie",
      electrical: "Pièces électriques",
      engine: "Pièces moteur",
      transmission: "Transmission",
      brakes: "Freins",
      suspension: "Suspension",
      interior: "Intérieur",
      accessories: "Accessoires"
    }
  },
  notifications: {
    messages: {
      new: "Nouveau message de {{sender}}",
      preview: "{{message}}"
    },
    orders: {
      new: "Nouvelle commande de {{buyer}}",
      preview: "{{quantity}}x {{product}}"
    },
    timeAgo: {
      justNow: "À l'instant",
      minutes: "Il y a {{count}}m",
      hours: "Il y a {{count}}h",
      days: "Il y a {{count}}j"
    },
    empty: "Aucune notification"
  },
  settings: {
    notifications: {
      title: "Paramètres des notifications",
      enable: "Activer les notifications",
      messages: "Notifications de messages",
      orders: "Notifications de commandes", 
      marketing: "Notifications marketing",
      updateSuccess: "Paramètres de notification mis à jour",
      updateError: "Échec de la mise à jour des paramètres de notification"
    }
  },
  rating: {
    outOf: "sur",
    reviews: "avis",
    writeReview: "Écrire un avis",
    updateReview: "Mettre à jour votre avis",
    commentPlaceholder: "Partagez votre expérience avec ce produit...",
    submit: "Soumettre l'avis",
    update: "Mettre à jour",
    submitSuccess: "Avis soumis avec succès",
    submitError: "Échec de la soumission de l'avis",
    loadError: "Échec du chargement des avis",
    loginRequired: "Veuillez vous connecter pour écrire un avis",
    cannotRateOwnProduct: "Vous ne pouvez pas évaluer votre propre produit",
    noReviews: "Aucun avis pour le moment"
  }
};

export default translation;